import TableCellDateDay from '../../Components/Includes/Table/TableCellDateDay'

export const date = {
  id: "date",
  sort: true,
  padding: true,
  label: "Date",
  component: TableCellDateDay
}
